
import { useState } from 'react';

export default function SETAFundingSection() {
  const [activeTab, setActiveTab] = useState('mandatory');

  return (
    <section className="section-wrap bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-heading">
            SETA Funding Assistance
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Maximise your training budget with our comprehensive SETA funding support
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12">
          <div>
            <div className="bg-[#2D7F3E] text-white p-6 rounded-xl mb-6">
              <h3 className="text-2xl font-bold mb-2">Reduce Training Costs by up to 75%</h3>
              <p className="text-green-100">
                Our SETA specialists help you access available funding to significantly reduce your training investment
              </p>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Expert Grant Applications</h4>
                  <p className="text-gray-600">Professional assistance with all SETA grant applications and submissions</p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Compliance Management</h4>
                  <p className="text-gray-600">Ensure all training meets SETA requirements and compliance standards</p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Documentation Support</h4>
                  <p className="text-gray-600">Complete documentation and reporting for successful grant claims</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="flex border-b">
              <button
                onClick={() => setActiveTab('mandatory')}
                className={`flex-1 py-4 px-6 font-semibold transition-colors ${
                  activeTab === 'mandatory'
                    ? 'bg-[#2D7F3E] text-white'
                    : 'text-gray-600 hover:text-[#2D7F3E]'
                }`}
              >
                Mandatory Grant Support
              </button>
              <button
                onClick={() => setActiveTab('discretionary')}
                className={`flex-1 py-4 px-6 font-semibold transition-colors ${
                  activeTab === 'discretionary'
                    ? 'bg-[#2D7F3E] text-white'
                    : 'text-gray-600 hover:text-[#2D7F3E]'
                }`}
              >
                Discretionary Grant Applications
              </button>
            </div>

            <div className="p-6">
              {activeTab === 'mandatory' && (
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-4">
                    Mandatory Grant Support
                  </h4>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-[#2D7F3E] mt-1 mr-2"></i>
                      <span className="text-gray-600">Skills development levy recovery assistance</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-[#2D7F3E] mt-1 mr-2"></i>
                      <span className="text-gray-600">Workplace Skills Plan (WSP) preparation</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-[#2D7F3E] mt-1 mr-2"></i>
                      <span className="text-gray-600">Annual Training Report (ATR) compilation</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-[#2D7F3E] mt-1 mr-2"></i>
                      <span className="text-gray-600">PIVOTAL programme alignment</span>
                    </li>
                  </ul>
                </div>
              )}

              {activeTab === 'discretionary' && (
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-4">
                    Discretionary Grant Applications
                  </h4>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-[#2D7F3E] mt-1 mr-2"></i>
                      <span className="text-gray-600">Large employer grant applications</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-[#2D7F3E] mt-1 mr-2"></i>
                      <span className="text-gray-600">Small employer grant support</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-[#2D7F3E] mt-1 mr-2"></i>
                      <span className="text-gray-600">Sector-specific funding opportunities</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-[#2D7F3E] mt-1 mr-2"></i>
                      <span className="text-gray-600">Special project funding assistance</span>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="text-center">
          <button className="btn btn-primary">
            Get SETA Funding Assessment
          </button>
        </div>
      </div>
    </section>
  );
}
